import axiosInstance from '../../axios/axiosInstance';
import { GET_EXTERNAL_SUB_CATEGORY, GET_SMART_INVENTORY, SYNC_SMART_INVENTORY, UPDATE_SMART_INVENTORY, GET_BRAND_CATEGORY_HIERARCHY, SAVE_CATEGORY_MAPPINGS, GET_CATEGORY_MAPPING, GET_VENDOR_SIZE_MAPPINGS, UPDATE_VENDOR_SIZE_MAPPINGS } from '../../constants';


export const getCategoryMappings = (props) => onResponse => {
    try {
        let BASE_URL = GET_CATEGORY_MAPPING;
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log('[getCategoryMappings] API Error:', err);
                onResponse({
                    success: false,
                    message: 'Failed to fetch category mappings',
                    error: err.response?.data || err.message
                });
            });
    } catch (error) {
        console.log('[getCategoryMappings] Unexpected Error:', error);
        onResponse({ 
            success: false,
            message: 'Something went wrong while fetching category mappings'
        });
    }
};


export const saveCategoryMappings = (props) => onResponse => {
    try {
        let BASE_URL = SAVE_CATEGORY_MAPPINGS;
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log('[saveCategoryMappings] API Error:', err);
                onResponse({
                    success: false,
                    message: 'Failed to save category mappings',
                    error: err.response?.data || err.message
                });
            });
    } catch (error) {
        console.log('[saveCategoryMappings] Unexpected Error:', error);
        onResponse({ 
            success: false,
            message: 'Something went wrong while saving category mappings'
        });
    }
};

export const getBrandCategoriesHierarchy = (props) => onResponse => {
    try {
        let BASE_URL = GET_BRAND_CATEGORY_HIERARCHY; // Adjust this URL to match your backend endpoint
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data); 
            })
            .catch((err) => {
                console.log('[getBrandCategoriesHierarchy] API Error:', err);
                onResponse({
                    success: false,
                    message: 'Failed to fetch brand categories hierarchy',
                    error: err.response?.data || err.message
                });
            });
    } catch (error) {
        console.log('[getBrandCategoriesHierarchy] Unexpected Error:', error);
        onResponse({ 
            success: false,
            message: 'Something went wrong while fetching brand categories hierarchy'
        });
    }
};

export const getExternalSubcategoriesByVendor = (props) => onResponse => {
    try {
        let BASE_URL = GET_EXTERNAL_SUB_CATEGORY; // Adjust this URL to match your backend endpoint
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
        onResponse({ message: 'Something went wrong' });
    }
};

export const getSmartInventorySettings = (props) => (onResponse) => {
    try {
        console.log("Fetching smart inventory settings with props:", props);
        axiosInstance.post(GET_SMART_INVENTORY, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response ? err.response.data : err);
            });
    } catch (error) {
        onResponse({ error: 'Exception occurred while fetching smart inventory settings.' });
    }
};

export const updateSmartInventorySettings = (props) => (onResponse) => {
    try {
        axiosInstance.post(UPDATE_SMART_INVENTORY, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response ? err.response.data : err);
            });
    } catch (error) {
        onResponse({ error: 'Exception occurred while updating smart inventory settings.' });
    }
}; 


export const syncInventoryNow = (payload) => (onResponse) => {
    try {
        axiosInstance.post(SYNC_SMART_INVENTORY, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response ? err.response.data : err);
            });
    } catch (error) {
        onResponse({ error: 'Exception occurred while syncing inventory.' });
    }
};


export const getSizeMappings = (props) => onResponse => {
    try {
        let BASE_URL = GET_VENDOR_SIZE_MAPPINGS; // Adjust this URL to match your backend endpoint
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
        onResponse({ message: 'Something went wrong' });
    }
};


export const saveSizeMappings = (props) => onResponse => {
    try {
        let BASE_URL = UPDATE_VENDOR_SIZE_MAPPINGS; // Make sure this constant is defined
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({
                    statusCode: err.response?.status || 500,
                    message: err.response?.data?.message || 'Failed to save size mappings',
                    error: err.message
                });
            });

    } catch (error) {
        console.log(error);
        onResponse({ 
            statusCode: 500,
            message: 'Something went wrong',
            error: error.message 
        });
    }
};
